import { gql } from "@apollo/client";

const Fragments = {
  textResourceItem: gql`
    fragment textResourceItem on TextResource {
      id
      textResourceCode
      label
      labelENU
      labelFRA
    }
  `
};

export default Fragments;
